import { VStack, Box } from '@hover/blueprint';
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import ToolDescription from './ToolDescription';

const CareersOurToolsMobile: React.FC = () => (
  <VStack display={{ base: 'flex', desktop: 'none' }} spacing={600} mb={900}>
    <Box flexDir="column" alignItems="flex-start">
      <StaticImage
        quality={100}
        placeholder="blurred"
        src="../../../assets/images/careers_our_tools_1.png"
        alt="Growth, Learning, and Development"
      />
      <ToolDescription
        mt={500}
        toolNumber={1}
        body="HOVER’s robust L&D program supports the greater culture of learning that exists
         at HOVER. Employees are given the tools and time to learn new skills, hear from industry
          experts, and advance in their careers. Employees personalize their growth with regular
          in-house offerings, dedicated time for self-directed learning, leadership coaching,
           generous per-employee funding for outside opportunities, and more."
        header="Growth, Learning, and Development"
      />
    </Box>
    <Box flexDir="column" alignItems="flex-start">
      <StaticImage
        quality={100}
        placeholder="blurred"
        src="../../../assets/images/careers_our_tools_2.png"
        alt="Diversity and Inclusion"
      />
      <ToolDescription
        mt={500}
        toolNumber={2}
        body="A diverse HOVER where employees experience true inclusion is good for employees
         and critical to our success. From recruitment practices that reduce the impact of
         systemic inequities to supporting the exemplary educational, policy, and community
          work of our employee-led D&I Committee, we are committed to addressing bias and
           fostering belonging at HOVER."
        header="Diversity and Inclusion"
      />
    </Box>
    <Box flexDir="column" alignItems="flex-start">
      <ToolDescription
        mt={500}
        toolNumber={3}
        body="We believe in work/life balance. We offer flexible work policies and seek to build warm,
        collegial relationships with one another regardless of role or location. We have monthly
        “Self-Care Days,” a paid day off, and a competitive suite of Health & Wellness benefits
        to support employees and their families at all stages of life."
        header="Wellness"
      />
      <StaticImage
        quality={100}
        placeholder="blurred"
        src="../../../assets/images/careers_our_tools_3.png"
        alt="Wellness"
      />
    </Box>
  </VStack>
);

export default CareersOurToolsMobile;
